import React from "react";
import { Field, ValidationMessaging } from "@ebscois/react-component-library";

export default function Attribute({ name, label, errorMessage, children }) {
  return (
    <Field
      id={name}
      label={label}
      message={
        <ValidationMessaging hasError={!!errorMessage} isHidden={!errorMessage}>
          {errorMessage}
        </ValidationMessaging>
      }
    >
      {children}
    </Field>
  );
}
